import { ModuleWithProviders, NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import { CoreModule } from "../../core/core.module";
import { PipesModule } from "../../pipes/pipes.module";
import { ApplicationService } from "./application/application.service";
import { ApplicationUIContainerSync } from "./application/application-container.service";
import { ApplicationFeedbackService } from "./application/application.feedback.service";
import { ApplicationRequestsService } from "./application/application.requests.service";
import { ApplicationValidators } from "./application/application.validators";
import { AuthService } from "./auth/auth.service";
import { AuthValidators } from "./auth/auth.validators";
import { IssueService } from "./issue/issue.service";
import { OrganizationService } from "./organization/organization.service";
import { RecordingService } from "./recording/recording.service";
import { ReferralService } from "./referral/referral.service";
import { SymbolService } from "./symbol/symbol.service";
import { UserService } from "./user/user.service";
import { ApplicationSessionsService } from "./application/application-sessions.service";
import { SettingsContainerService } from "./settings/settings-container.service";
import {AdminService} from "./admin/admin.service";

@NgModule({
    imports: [CommonModule, RouterModule, CoreModule, PipesModule],
    exports: []
})
export class SharedModule {
    static forRoot(): ModuleWithProviders<SharedModule> {
        return {
            ngModule: SharedModule,
            providers: [
                AdminService,
                ApplicationService,
                ApplicationUIContainerSync,
                ApplicationFeedbackService,
                ApplicationRequestsService,
                ApplicationSessionsService,
                ApplicationValidators,
                AuthService,
                AuthValidators,
                IssueService,
                OrganizationService,
                RecordingService,
                ReferralService,
                SettingsContainerService,
                SymbolService,
                UserService
            ]
        };
    }
}
